import type { CSSProperties } from 'react';
import { imageByPath } from '@/assets';
import styles from './holo.module.css';

/** The projector sprite (art/props/holo-projector), drawn under the hologram. */
const BASE = imageByPath['props/holo-projector'];

/**
 * Alex's hologram projector as a frame for the 3D mouth (holo.module.css): the frame's class and
 * style (the sprite), and the class of the element the mouth is drawn into.
 */
export function holoFrame(on: boolean): { className: string; style: CSSProperties } {
  return {
    className: `${styles.holo ?? ''} ${on ? (styles.on ?? '') : ''}`,
    style: BASE ? ({ '--holo-base': `url(${BASE.url})` } as CSSProperties) : {},
  };
}

export const HOLO_MODEL = styles.model ?? '';
